/* eslint-disable @typescript-eslint/no-non-null-assertion */
import type { CustomFieldResource, CustomFieldValueResource } from "@octopusdeploy/octopus-server-client";
import * as React from "react";
import BaseComponent from "~/components/BaseComponent/index";
import { MultiSelect } from "~/components/MultiSelect/MultiSelect";
import type { SelectItem } from "~/components/VirtualListWithKeyboard/SelectItem";
import type FormFieldProps from "~/components/form/FormFieldProps";
import CustomField from "../CustomField";
interface CustomFieldMultiSelectionProps extends FormFieldProps<string[]> {
    customField?: CustomFieldResource;
    autoFocus?: boolean;
}
interface CustomFieldSelectionState {
    customField: CustomFieldResource | null;
}
const CustomFieldResourceMultiSelect = MultiSelect<CustomFieldValueResource>();
export class CustomFieldMultiSelect extends BaseComponent<CustomFieldMultiSelectionProps, CustomFieldSelectionState> {
    constructor(props: CustomFieldMultiSelectionProps) {
        super(props);
        this.state = {
            customField: this.props.customField || null,
        };
    }
    chipRenderer = (customField: CustomFieldResource, r: CustomFieldResource | SelectItem, onRequestDelete: () => void) => {
        const customFieldValue = customField.Values!.find((f) => f.Id === r.Id);
        return (<CustomField onRequestDelete={onRequestDelete} deleteButtonAccessibleName={`Delete ${customFieldValue!.Name}`} description={customFieldValue!.Description} customFieldValueName={customFieldValue!.Name} customFieldValueColor={customFieldValue!.Color}/>);
    };
    render() {
        const customField = this.state.customField;
        if (!customField || !customField.Values || customField.Values.length === 0) {
            return null;
        }
        const selected = this.props.value ? customField.Values.filter((f) => this.props.value!.indexOf(f.Id!) !== -1).map((f) => f.Id) : [];
        const accessibleName = `customFieldFilter-${customField.Name}`;
        return (<CustomFieldResourceMultiSelect accessibleName={accessibleName} onChange={(items) => this.props.onChange(items)} key={customField.Id} value={selected} items={customField.Values.sort((f1, f2) => f1.SortOrder - f2.SortOrder)} renderChip={(r: CustomFieldResource | SelectItem, dc) => this.chipRenderer(customField, r, dc)} fieldName={`${customField.Name} (Multi Select)`} description={customField.Description} autoFocus={this.props.autoFocus}/>);
    }
    static displayName = "CustomFieldMultiSelect";
}
